import React, {PureComponent} from 'react';
import {withRouter} from 'react-router';
import jsonLogic from 'json-logic-js';

import {getVariables} from '../../lib/json-logic-utils';
import LineChart from '../LineChart';
import Tooltip from '../Tooltip';
import NoDataWidget from '../NoDataWidget';
import LargeWidgetValue from '../LargeWidgetValue';
import Number from '../Number';
import WidgetHeader from "../WidgetHeader";

class TrendWidget extends PureComponent {
  handleClickPoint = point => {
    const {history} = this.props;

    history.push(`${history.location.pathname}/data/${point.payload.row.id}`);
  }

  render() {
    const {widget, sheetsById, rows, questions, preview, id, options} = this.props;
    const data = rows.map(row => {
      const variables = getVariables(row.answers, questions);

      if (widget.filter && !jsonLogic.apply(widget.filter, variables)) {
        return null;
      }

      return {
        result: jsonLogic.apply(widget.map, variables),
        row
      };
    }).filter(Boolean);

    if (data.length < 1) {
      return <NoDataWidget id={id} title={widget.title} options={options} question={widget}/>;
    }
    else if (data.length === 1) {
      return (
          <React.Fragment>
            <WidgetHeader title={widget.title} options={options} id={id}/>
            <LargeWidgetValue>
              <Number>{data[0].result}</Number>
            </LargeWidgetValue>
          </React.Fragment>
      );
    }

    return (
      <LineChart
        id={id}
        preview={preview}
        question={widget}
        data={data}
        valueKey="result"
        onClick={this.handleClickPoint}
        options={options}
        tooltip={point => {
          const sheet = sheetsById[point.row.sheetId];

          return (
            <Tooltip>
              {Object.keys(sheetsById).length > 1 && (
                <Tooltip.Title>{sheet.name || 'Unnamed sheet'}</Tooltip.Title>
              )}
              <Tooltip.Value>{isNaN(point.result) ? 'No Value' : point.result}</Tooltip.Value>
              <Tooltip.Footer>{new Date(point.row.dates.lastModified).toLocaleString()}</Tooltip.Footer>
            </Tooltip>
          );
        }}
      />
    );
  }
}

export default withRouter(TrendWidget);